import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Dialog from 'components/modals/Dialog';
import DialogTitle from 'components/modals/DialogTitle';

import ScheduleList from './ScheduleList';


class ScheduleModal extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    toggle: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    className: '',
  };

  render() {
    return (
      <div className={this.props.className}>
        <Dialog
          open={this.props.isOpen}
          onBackdropClick={this.props.toggle}
          size="large"
        >
          <DialogTitle id="dialog-title" disableTypography>
            Manage schedules
          </DialogTitle>
          <ScheduleList toggleModal={this.props.toggle} />
        </Dialog>
      </div>
    );
  }
}

export default compose(
  connect(
    state => ({
      schedules: state.schedules,
    }),
    { },
  ),
  withNamespaces('common'),
)(ScheduleModal);
